import { render, staticRenderFns } from "./AiCourseWizardDlg.vue?vue&type=template&id=c3a41a94&scoped=true&"
import script from "./AiCourseWizardDlg.vue?vue&type=script&lang=ts&"
export * from "./AiCourseWizardDlg.vue?vue&type=script&lang=ts&"
import style0 from "./AiCourseWizardDlg.vue?vue&type=style&index=0&id=c3a41a94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a41a94",
  null
  
)

export default component.exports